/**
 * Position des toasts de la v2 (lib/toast.tsx) : sous le bas RÉEL de l'en-tête du site, bandeau promo compris.
 */
/** En-têtes fixes ou collants connus des thèmes (monday-2026 : #site-header ; Uncode : #masthead). */
const HEADER_SELECTORS = '#site-header, #masthead, .site-header, header.site-header';

/** Marge haute du toast : 16 px sous le bas de l'en-tête du site visible en haut de l'écran (0 s'il n'y en a pas). */
export function toastTopOffset(doc: Document = document): number {
  let bottom = 0;
  doc.querySelectorAll<HTMLElement>(HEADER_SELECTORS).forEach((header) => {
    const rect = header.getBoundingClientRect();
    // En haut de l'écran (bandeau promo éventuel au-dessus : #site-header commence à 30 ou 34 px).
    if (rect.height > 0 && rect.bottom > 0 && rect.top < 200 && rect.bottom > bottom) bottom = rect.bottom;
  });
  return Math.round(bottom) + 16;
}
